import * as SystemUI from 'expo-system-ui';
import { useLayoutEffect } from 'react';
import { Platform } from 'react-native';
import type { ThemeMode } from '@/stores/useThemeStore';
import { getAppBackgroundColor } from '@/utils/appBackground';

export default function useSetAppBackground(theme: ThemeMode) {
  useLayoutEffect(() => {
    void SystemUI.setBackgroundColorAsync(
      getAppBackgroundColor(theme, Platform.OS),
    );
  }, [theme]);
}
